import { useSelector } from 'react-redux';
import { Store } from 'types/Store';
import { UserStore } from 'modules/user/userReducer';

export type UserSelectorResult = UserStore & {
  isClient: boolean;
};

export function useUser(): UserSelectorResult {
  const user = useSelector<Store, UserStore>((state) => state.user);

  return {
    ...user,
    isClient: user.role === 'client',
  };
}
